import React from 'react'
import { Typography } from '@material-ui/core'
import clsx from 'clsx'
import CMSText, { isPrismicText } from '../Global/CMSText'
import {
  PrismicProduct,
  PrismicProductData,
} from '@/interfaces/common/prismicProduct'

type ProductSettingsSource =
  | PrismicProduct
  | PrismicProductData
  | { data?: PrismicProductData }
  | null
  | undefined

const getProductData = (
  productSettings?: ProductSettingsSource
): PrismicProductData | undefined => {
  if (!productSettings) return undefined
  if ('above_product_description_text' in productSettings) {
    return productSettings as PrismicProductData
  }
  return (productSettings as PrismicProduct | { data?: PrismicProductData })
    ?.data
}

type AboveProductDescriptionTextProps = {
  productSettings?: ProductSettingsSource
  className?: string
}

const AboveProductDescriptionText = ({
  productSettings,
  className,
}: AboveProductDescriptionTextProps) => {
  const text = getProductData(productSettings)?.above_product_description_text

  if (!isPrismicText(text)) {
    return null
  }

  return (
    <Typography
      component="div"
      variant="caption"
      className={clsx('above-product-description-text', className)}
    >
      <CMSText data={text} />
    </Typography>
  )
}

export const hasAboveProductDescriptionText = (
  productSettings?: ProductSettingsSource
): boolean => {
  return isPrismicText(
    getProductData(productSettings)?.above_product_description_text
  )
}

export default AboveProductDescriptionText
